exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-footer .footer-logo[data-v-0a6bd0e3] {\n  left: -26px;\n}\n.main-footer.statical[data-v-0a6bd0e3] {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 50;\n}\n@media print {\n.main-footer[data-v-0a6bd0e3] {\n    display: none !important;\n}\n}\n", ""]);

// exports
